import { render, staticRenderFns } from "./flujoExpedienteDigital.vue?vue&type=template&id=5c31cbaa&scoped=true"
import script from "./flujoExpedienteDigital.vue?vue&type=script&lang=js"
export * from "./flujoExpedienteDigital.vue?vue&type=script&lang=js"
import style0 from "./flujoExpedienteDigital.vue?vue&type=style&index=0&id=5c31cbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c31cbaa",
  null
  
)

export default component.exports